<template>
  <div class="footer-box">
    <flex justify="between">
      <div>
        <img
          src="@/static/img/home/logo-white.png"
          class="logo-img"
        >
        <flex class="link-box">
          <a @click.stop="gotoAboutUs()">关于我们</a>
          <a>使用指南</a>
          <a>授权协议</a>
          <a>隐私策略</a>
        </flex>
      </div>
      <div>
        <flex
          align="center"
          class="app-box"
        >
          <img src="@/static/img/home/app-icon.png">
          <span>视阅APP</span>
        </flex>
        <p class="app-sumarry">视阅app客户端是专业的智慧化媒体和产业服务平台。以期刊出版为引领，提供书刊订阅、影像摄制、研学旅行、创意设计、会务会展、教育培训、文化旅游和品牌推广等服务。</p>
      </div>
    </flex>
    <div class="divider" />
    <flex justify="between">
      <div class="info-wrapper">
        <p>@贵州新闻图片社有限公司
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="color: #fff;"
          >黔ICP备13002800号-2</a> 营业执照：91520000429200283Q
        </p>
        <p>热线：0851-86822572工作日9:00 - 17:00 投稿邮箱：646896024@qq.com</p>
        <p>贵州省贵阳市观山湖区长岭北路贵阳国际会议展览中心D区D1栋7-18层1号</p>
      </div>
      <flex
        justify="between"
        class="qrcode-wrapper"
      >
        <flex
          direction="column"
          jutify="center"
          align="center"
          class="qrcode-item"
        >
          <img src="@/static/img/home/newshiyuelogo.jpg">
          <span>下载视阅app</span>
        </flex>
        <flex
          direction="column"
          jutify="center"
          align="center"
          class="qrcode-item"
        >
          <img src="@/static/img/home/shiyuxiaochengxu.jpg">
          <span>视阅小程序</span>
        </flex>
        <flex
          direction="column"
          jutify="center"
          align="center"
          class="qrcode-item"
        >
          <img src="@/static/img/home/shiyugongzhonghao.jpg">
          <span>微信公众号</span>
        </flex>
      </flex>
    </flex>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    gotoAboutUs () {
      let routerData = this.$router.resolve({
        path: '/aboutus'
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
.footer-box
  color #CCC
  background #141414
  padding 64px 13% 90px 13%
  box-sizing border-box
  font-size 14px
  margin-top 150px
.logo-img
  width 100px
  height 34px
.link-box>a
  margin-top 27px
  cursor pointer
  padding-right 10px
  margin-right 10px
  transition all 0.2s
  &:not(:last-child)
    border-right 1px solid #ccc
  &:hover
    opacity 0.8
.app-box
  font-size 16px
  color #fff
  &>img
    width 26px
    margin-right 8px
.app-sumarry
  width 370px
  font-size 12px
  line-height 22px
  margin-top 20px
.divider
  margin 20px 0px
  height 1px
  background #303030
.info-wrapper
  line-height 32px
.qrcode-wrapper
  width 370px
.qrcode-item
  font-size 12px
  color #fff
  &>img
    width 88px
    margin-bottom 16px
</style>
